<template>
  <div id="assignment-performance">
    <div class="table-wrapper">
      <el-table
        ref="multipleTable"
        :data="assignedClasses"
        :empty-text="$t('common.no_values')"
        :default-sort="{ prop: 'created_at', order: 'descending' }"
        v-loading="loading"
      >
        <el-table-column
          prop="group_name"
          sort-by="group_name"
          sortable
          :label="$t($i18nLabelsHelper(currentOrganizationType, `group_name`))"
        >
          <template slot-scope="scope">
            <template v-if="hasPermission(scope.row)">
              <el-link
                type="primary"
                :underline="false"
                @click="redirectToAssignment(scope.row)"
                class="assignment-name"
              >
                {{ formatName(scope.row) }}
              </el-link>
            </template>
            <template v-else>
              {{ formatName(scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="name" sort-by="name" sortable :label="$t('homework_library.table.assignment_name')">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column
          dataType="date"
          sort-by="start_date"
          prop="start_date"
          sortable
          :label="$t('homework_library.table.start_date')"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.start_date) }}
          </template>
        </el-table-column>
        <el-table-column
          dataType="date"
          sort-by="due_date"
          prop="due_date"
          sortable
          :label="$t('homework_library.table.due_date')"
          v-loading="loading"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.due_date) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { format } from "date-fns";
import { DATE_FORMAT } from "@/constants/generic";

export default {
  components: {},
  props: {
    assignedClasses: {
      type: Array,
      default: () => [{}],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    lessonTypes: {
      type: Array,
      default: () => [{}],
    },
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      currentOrganizationId: "organization/currentOrganizationId",
      userIsAdmin: "organization/isOrganizationAdmin",
      userIsGeneralAdmin: "organization/isGeneralAdmin",
      userIsAssociateAdmin: "organization/isOrganizationAssociateAdmin",
      userIsElsaAdmin: "user/isElsaAdmin",
      userOrganizationsData: "organization/userOrganizationsData",
    }),
  },
  data() {
    return {
      title: "awesome!",
    };
  },
  methods: {
    formatDate(date) {
      return isNaN(Date.parse(date)) ? date : format(new Date(date), DATE_FORMAT);
    },
    formatScore(score) {
      return score ? Math.round(score) + "%" : "--";
    },
    formatName(row) {
      return row.organization != this.currentOrganizationId
        ? `${row.organization_name} - ${row.group_name}`
        : row.group_name;
    },
    hasPermission(row) {
      if (this.userIsElsaAdmin || this.userIsGeneralAdmin) {
        return true;
      }
      const filteredByOrgId = this.userOrganizationsData.filter(
        item => item.organizationId == this.currentOrganizationId
      );
      if (filteredByOrgId.length === 0) {
        return false;
      }
      const filteredByGroupId = filteredByOrgId.filter(item => {
        return item.owner_groups.some(group => group.id == row.group);
      });
      if (filteredByGroupId.length === 0) {
        return false;
      }
      return true;
    },
    redirectToAssignment(row) {
      const url = `/organization/${row.organization}/classes/${row.group}/assignments/${row.id}`;

      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
#assignment-performance {
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 24px;
}

.assignment-name {
  font-size: 16px;
  line-height: 24px;
}

.info-row {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }

  .value {
    text-transform: none;
    margin-bottom: 4px;
  }
}

.table-row {
  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #757575;
    margin: 0;
    text-align: initial;
  }
}

.data-row {
  p {
    text-transform: none;
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .date {
    text-align: left;
  }
}

.el-row:nth-child(2) .data-row {
  .date {
    font-weight: 600 !important;
  }

  .score {
    font-weight: 600 !important;
  }
}

.icon-row {
  padding: 12px 0px 0px 12px;
}

.score {
  text-align: center !important;
}

.elsa-table-layout-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    align-self: center;
  }

  label {
    font-family: SF Pro Display, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #121131;
  }
}

::v-deep .el-table {
  border: 1px solid #e5e5ea;
  border-radius: 12px;
  padding: 0 16px;
}

::v-deep .el-table thead tr {
  background: #f9f9f9;
}

::v-deep .el-table .el-table__header-wrapper .cell {
  color: #757575;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
